<template>
  <main class="hongkong">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/hongkong/2025/menu.vue';
import hero from '@/components/hongkong/2025/hero.vue';
import agenda from '@/components/hongkong/2025/agenda.vue';
import sponsors from '@/components/hongkong/2025/sponsors.vue';
import speakers from '@/components/hongkong/2025/speakers.vue';
import presenters from '@/components/hongkong/2025/presenters.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers
  },
};
</script>

<style lang="scss" scoped>
  .hongkong {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>